import React from 'react';
import { 
  PencilIcon,
  XCircleIcon
} from '../../../../components/ui/Icons';
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardContent, 
  Button
} from '../../../../components/ui';
import { ClockIcon } from '../../../../components/ui/Icons';
import SendReminderButton from '../../components/SendReminderButton';

const ApprovalActions = ({ 
  selectedRecord, 
  canTakeAction, 
  canEdit = true,
  statusValue, 
  onHandleAction,
  onShowEmailHistory
}) => {
  // Normalize status value to a lowercase string (handles string or { name: string })
  const rawStatus = statusValue || selectedRecord?.status?.name || selectedRecord?.status || '';
  const normalizedStatus = typeof rawStatus === 'string' ? rawStatus.toLowerCase() : String(rawStatus).toLowerCase();
  const isCancelled = normalizedStatus === 'cancelled';

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm flex items-center">
          <PencilIcon className="w-4 h-4 mr-2" />
          Actions
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 gap-2">
          {canEdit ? (
            <Button
              onClick={() => {
                console.log('Edit button clicked, calling onHandleAction with edit');
                onHandleAction('edit');
              }}
              className="w-full justify-start"
              variant="default"
              size="sm"
            >
              <PencilIcon className="w-4 h-4 mr-2" />
              Edit Request
            </Button>
          ) : (
            <div className="p-2 text-xs text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 rounded border border-gray-200 dark:border-gray-700">
              {isCancelled ? 'This request has been cancelled and cannot be edited.' : 'This request cannot be edited in its current status.'}
            </div>
          )}
          {canTakeAction && (
            <div className="space-y-1">
              <Button
                onClick={() => onHandleAction('cancel')}
                className="w-full justify-start !bg-orange-600 hover:!bg-orange-700 !text-white !border-orange-600 hover:!border-orange-700"
                size="sm"
                title="Cancel this approval request. Only pending requests can be cancelled."
              >
                <XCircleIcon className="w-4 h-4 mr-2" />
                Cancel Request
              </Button>
              <p className="text-xs text-gray-700 dark:text-gray-300 mt-1 px-1 opacity-100">
                Only pending requests can be cancelled
              </p>
            </div>
          )}

          {/* Email Notification History button */}
          {selectedRecord && (
            <Button
              onClick={onShowEmailHistory}
              className="w-full justify-start"
              variant="outline"
              size="sm"
            >
              <ClockIcon className="w-4 h-4 mr-2" />
              View Email Notification History
            </Button>
          )}

          {/* Send Reminder button – visible for pending requests */}
          {normalizedStatus === 'pending' && (
            <SendReminderButton
              approvalId={selectedRecord.id}
              approvalRequest={selectedRecord}
              onSuccess={() => {
                console.log('Reminder sent, refreshing approval data');
                if (onHandleAction) {
                  onHandleAction('refresh');
                }
              }}
              onError={(error) => console.error('Failed to send reminder:', error)}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ApprovalActions;

